var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"faq-item"},[_c('img',{staticClass:"faq-icon",attrs:{"src":_vm.icon,"alt":"icon"}}),_c('h2',{staticClass:"faq-question"},[_vm._v(_vm._s(_vm.question))]),_c('p',{staticClass:"faq-answer"},[_vm._v(_vm._s(_vm.answer))]),(_vm.note)?_c('p',{staticClass:"faq-note"},[_vm._v(_vm._s(_vm.note))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }